// frontend/src/services/profileService.js
// Deleting one's own account (docs/openapi.yaml, call map section 17): a preview of what goes and
// whether it is allowed, then the delete. Counts only, never lesson names.
import api from './api';

// { allowed, reason: open_run | last_admin, unsharedLessons, sharedLessons }
export const getDeletionPreview = async () => (await api.get('/api/users/profile/deletion')).data;

export const deleteMyAccount = async () => (await api.delete('/api/users/profile')).data;
